module.exports = book => {
    return `/books/${book._id}`;
};
